<template>
  <div class="w-full flex flex-col items-center p-2">
    <div v-if="status === 'waiting'" class="qrcode-container flex flex-col items-center">
      <a-spin size="large" />
      <p class="text-slate-500 dark:text-slate-400 mt-5 text-sm">正在生成二维码...</p>
    </div>

    <div v-else-if="status === 'ready'" class="qrcode-container flex flex-col items-center">
      <div class="qrcode-wrapper">
        <img :src="imgUrl" alt="扫码登录二维码" class="qrcode-img" />
      </div>
      <div class="text-primary cursor-pointer hover:text-primary/80 pt-3" @click="$emit('refresh')">刷新二维码</div>
      <div class="text-slate-700 dark:text-slate-300 py-1 text-sm">微信扫一扫/识别，关注公众号后返回即可登录</div>
    </div>

    <div v-else-if="status === 'expired'" class="qrcode-container qrcode-expired flex flex-col items-center">
      <div class="qrcode-expired-icon">
        <WarningOutlined />
      </div>
      <p class="qrcode-expired-text">二维码已过期</p>
      <a-button type="primary" class="qrcode-refresh-btn" @click="$emit('refresh')" :loading="status === 'waiting'">
        重新生成二维码
      </a-button>
    </div>

    <div v-else-if="status === 'success'" class="qrcode-container flex flex-col items-center">
      <CheckCircleOutlined class="text-6xl text-green-500" />
      <p class="text-slate-700 dark:text-slate-300 mt-5 text-sm">登录成功，正在跳转...</p>
    </div>
  </div>
</template>

<script>
import { WarningOutlined, CheckCircleOutlined } from '@ant-design/icons-vue'

export default {
  name: 'QrcodeLoginPanel',
  components: { WarningOutlined, CheckCircleOutlined },
  props: {
    status: { type: String, required: true },
    imgUrl: { type: String, default: '' }
  },
  emits: ['refresh']
}
</script>

<style scoped>
.qrcode-container {
  @apply w-full flex items-center justify-center flex-col;
}

.qrcode-wrapper {
  position: relative;
  width: 220px;
  height: 220px;
  @apply bg-white rounded-lg p-2.5 flex items-center justify-center shadow-sm border border-solid border-slate-200/55;
}

.qrcode-img {
  width: 200px;
  height: 200px;
  display: block;
}

.qrcode-expired {
  @apply bg-slate-50/50 dark:bg-slate-900/50 rounded-lg px-5 py-10;
}

.qrcode-expired-icon {
  @apply w-20 h-20 flex items-center justify-center rounded-full text-5xl text-red-500;
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(239, 68, 68, 0.2));
}

.qrcode-expired-text {
  @apply mt-5 text-base text-slate-600 dark:text-slate-400 font-medium;
}

.qrcode-refresh-btn {
  @apply mt-5 px-6 py-2.5 rounded-full text-sm font-medium h-auto;
}
</style>
